import { AircraftTimes } from '@sd-portal/post-flight/models-util';

export class TakeoffLandingInformation {
  dayTakeoffs: number;
  dayLandings: number;
  nightTakeoffs: number;
  nightLandings: number;

  constructor() {
    this.dayTakeoffs = 0;
    this.dayLandings = 0;
    this.nightTakeoffs = 0;
    this.nightLandings = 0;
  }
}

export class CrewTakeoffLanding {
  firstName: string;
  lastName: string;
  role: string;
  personId: number;
  flightCrewMemberId: number;
  formIndex: number;

  initialTakeoffLanding: TakeoffLandingInformation;
  currentTakeoffLanding: TakeoffLandingInformation;

  constructor() {
    this.initialTakeoffLanding = new TakeoffLandingInformation();
    this.currentTakeoffLanding = new TakeoffLandingInformation();
  }

  dayTakeoffsModified(): boolean {
    return this.initialTakeoffLanding.dayTakeoffs !== this.currentTakeoffLanding.dayTakeoffs;
  }

  dayLandingsModified(): boolean {
    return this.initialTakeoffLanding.dayLandings !== this.currentTakeoffLanding.dayLandings;
  }

  nightTakeoffsModified(): boolean {
    return this.initialTakeoffLanding.nightTakeoffs !== this.currentTakeoffLanding.nightTakeoffs;
  }

  nightLandingsModified(): boolean {
    return this.initialTakeoffLanding.nightLandings !== this.currentTakeoffLanding.nightLandings;
  }
}

export class EngineTakeoffLanding {
  name: string;
  engineId: number;
  cycles: number;
}

export class FlightCrewTakeoffLanding {
  postedFlightId: number;
  crewTakeoffOverride: number;
  aircraftTimes: AircraftTimes;
  crewMembers: CrewTakeoffLanding[];

  constructor() {
    this.crewTakeoffOverride = 0;
    this.crewMembers = [];
  }

  airframeLandings(): number {
    if (this.aircraftTimes) {
      return this.aircraftTimes.airframeTotalLandings;
    }

    return 0;
  }

  totalLandings(): number {
    let retLandings = 0;
    if (this.crewMembers.length > 0) {
      for (const crewMember of this.crewMembers) {
        retLandings +=
          crewMember.initialTakeoffLanding.dayLandings +
          crewMember.initialTakeoffLanding.nightLandings;
      }
    }

    return retLandings;
  }

  totalTakeoffs(): number {
    let retTakeoffs = 0;
    if (this.crewMembers.length > 0) {
      for (const crewMember of this.crewMembers) {
        retTakeoffs +=
          crewMember.initialTakeoffLanding.dayTakeoffs +
          crewMember.initialTakeoffLanding.nightTakeoffs;
      }
    }

    return retTakeoffs;
  }
}
